

export const frontMatter = {
	sidebar_position: 2,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/adjectives.html'
};
export const contentTitle = 'Прилагателни';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-bg-docusaurus-plugin-content-docs-current-learn-grammar-adjectives-md-064.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Инфлексия",
  "id": "инфлексия",
  "level": 2
}, {
  "value": "Основни окончания",
  "id": "основни-окончания",
  "level": 3
}, {
  "value": "Твърди прилагателни",
  "id": "твърди-прилагателни",
  "level": 3
}, {
  "value": "Меки прилагателни",
  "id": "меки-прилагателни",
  "level": 3
}, {
  "value": "Кратка форма",
  "id": "кратка-форма",
  "level": 2
}, {
  "value": "Наречия",
  "id": "наречия",
  "level": 2
}, {
  "value": "Степени на сравнение",
  "id": "степени-на-сравнение",
  "level": 2
}, {
  "value": "Аналитично сравнение",
  "id": "аналитично-сравнение",
  "level": 3
}, {
  "value": "Синтетично сравнение",
  "id": "синтетично-сравнение",
  "level": 3
}, {
  "value": "Нередовни сравнения",
  "id": "нередовни-сравнения",
  "level": 3
}, {
  "value": "Суперлатив",
  "id": "суперлатив",
  "level": 3
}, {
  "value": "Допълнителни форми",
  "id": "допълнителни-форми",
  "level": 3
}, {
  "value": "Пример",
  "id": "пример",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDAdjectives1, MDAdjectives2, MDAdjectives3, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDAdjectives1) _missingMdxReference("MDAdjectives1", true);
  if (!MDAdjectives2) _missingMdxReference("MDAdjectives2", true);
  if (!MDAdjectives3) _missingMdxReference("MDAdjectives3", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "прилагателни",
        children: "Прилагателни"
      })
    }), "\n", _jsx(_components.h2, {
      id: "инфлексия",
      children: "Инфлексия"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Прилагателните съвпадат със съществителното, което променят по род, падеж и число. Склонението винаги е правилно. Трябва обаче да запомните три неща:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Прилагателните са силно засегнати от правилата ", _jsx(_components.a, {
          href: "/bg/learn/phonology#o--e",
          children: "o/e"
        }), " и ", _jsx(_components.a, {
          href: "/bg/learn/phonology#y--ie",
          children: "y/i"
        }), ", което означава, че се прави разлика между твърди и меки основи: ако основата завършва на ", _jsx(_components.code, {
          children: "š"
        }), ", ", _jsx(_components.code, {
          children: "ž"
        }), ", ", _jsx(_components.code, {
          children: "č"
        }), "  или ", _jsx(_components.code, {
          children: "j"
        }), ", тогава всеки ", _jsx(_components.code, {
          children: "-o-"
        }), " става ", _jsx(_components.code, {
          children: "-e-"
        }), " и всеки ", _jsx(_components.code, {
          children: "-y-"
        }), " става ", _jsx(_components.code, {
          children: "-i-"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "Точно както при съществителните имена, винителният падеж на има същата форма като родителния падеж, когато съответното съществително е от мъжки род и одушевено, както в единствено, така и в множествено число."
      }), "\n", _jsx(_components.li, {
        children: "С изключение на прилагателните, отнасящи се до съществителни от мъжки род, одушевени, номинативното и винителното множествено число са еднакви за всички родове."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "основни-окончания",
      children: "Основни окончания"
    }), "\n", _jsx(_components.p, {
      children: "Основните окончания (отнасящи се не само за прилагателни, но и за притежателни местоимения, показателни местоимения и други подобни) са:"
    }), "\n", _jsx(MDAdjectives1, {}), "\n", _jsx(_components.h3, {
      id: "твърди-прилагателни",
      children: "Твърди прилагателни"
    }), "\n", _jsxs(_components.p, {
      children: ["Пример за склонение на твърди прилагателни: ", _jsx(TransliteratorElement, {
        children: "dobry"
      }), " „добър”:"]
    }), "\n", _jsx(MDAdjectives2, {}), "\n", _jsx(_components.h3, {
      id: "меки-прилагателни",
      children: "Меки прилагателни"
    }), "\n", _jsxs(_components.p, {
      children: ["Пример за склонение на меки прилагателни: ", _jsx(TransliteratorElement, {
        children: "svěži"
      }), " „пресен”:"]
    }), "\n", _jsx(MDAdjectives3, {}), "\n", _jsx(_components.h2, {
      id: "кратка-форма",
      children: "Кратка форма"
    }), "\n", _jsxs(_components.p, {
      children: ["Малък брой прилагателни съществуват в така наречената кратка форма, реликт от неопределеното склонение на прилагателните в общия славянски. Тази кратка форма се различава от обикновените прилагателни само в мъжки именителен падеж единствено число, като пропуска окончанието ", _jsx(_components.code, {
        children: "-y"
      }), "/", _jsx(_components.code, {
        children: "-i"
      }), ". Най-често срещаните примери са притежателните прилагателни ", _jsx(_components.code, {
        children: "-ov"
      }), " и ", _jsx(_components.code, {
        children: "-in"
      }), ", изразяващи съответно собственост от мъжки и женски род: ", _jsx(TransliteratorElement, {
        children: "Petrov dom"
      }), " „къщата на Петър”, ", _jsx(TransliteratorElement, {
        children: "materin stol"
      }), " „масата на майката”. Всички останали форми са правилни: ", _jsx(TransliteratorElement, {
        children: "Petrova kniga"
      }), " „книгата на Петър”, ", _jsx(TransliteratorElement, {
        children: "na materinom stolu"
      }), " „на масата на майката”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Тези притежателни прилагателни се използват само когато притежателят е една дума. В други случаи се използва родителен падеж: ", _jsx(TransliteratorElement, {
        children: "bratova kniga"
      }), " „книгата на брат ми”, но: ", _jsx(TransliteratorElement, {
        children: "kniga mojego brata"
      }), " „книгата на брат ми”; ", _jsx(TransliteratorElement, {
        children: "Puškinova poezija"
      }), " „Поезията на Пушкин”, но: ", _jsx(TransliteratorElement, {
        children: "poezija Aleksandra Puškina"
      }), " „Поезията на Александър Пушкин”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Кратката форма може да се използва и когато прилагателното образува предиката на изречението: ", _jsx(TransliteratorElement, {
        children: "Petr jest ščestliv"
      }), " „Петър е щастлив”, ", _jsx(TransliteratorElement, {
        children: "dom jest velik"
      }), " „къщата е голяма” и т.н. Това обаче не е задължително и в повечето случаи хората просто ще напише: ", _jsx(TransliteratorElement, {
        children: "Petr jest ščestlivy"
      }), " и ", _jsx(TransliteratorElement, {
        children: "dom jest veliky"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "наречия",
      children: "Наречия"
    }), "\n", _jsxs(_components.p, {
      children: ["Наречията могат да бъдат получени от прилагателни с помощта на окончанието ", _jsx(_components.code, {
        children: "-o"
      }), " (", _jsx(_components.code, {
        children: "-e"
      }), " след мека съгласна). С други думи, те са идентични със среден род единствено число: ", _jsx(TransliteratorElement, {
        children: "dobro"
      }), " „добре”, ", _jsx(TransliteratorElement, {
        children: "svěže"
      }), " „прясно”."]
    }), "\n", _jsx(_components.h2, {
      id: "степени-на-сравнение",
      children: "Степени на сравнение"
    }), "\n", _jsx(_components.p, {
      children: "Сравнителните и суперлативите могат да бъдат изградени по два начина: проста (аналитична) форма и по-сложна (синтетична) форма."
    }), "\n", _jsx(_components.h3, {
      id: "аналитично-сравнение",
      children: "Аналитично сравнение"
    }), "\n", _jsxs(_components.p, {
      children: ["Този начин за образуване на сравнение е най-лесният за използване. Просто имайте основната форма (положителното) на прилагателно или наречие, предшествано от ", _jsx(TransliteratorElement, {
        children: "vyše"
      }), " или ", _jsx(TransliteratorElement, {
        children: "bolje"
      }), " „повече”: ", _jsx(TransliteratorElement, {
        children: "vyše prosty"
      }), " „по-просто = по-просто”. Това решение може да се използва за всички прилагателни и наречия, но най-вероятно се среща в случай на много дълги думи, чужди думи и причастия: ", _jsx(TransliteratorElement, {
        children: "vyše/bolje sintetičny"
      }), " „по-синтетичен“, ", _jsx(TransliteratorElement, {
        children: "vyše/bolje smrdeči"
      }), " „по-вонящ“."]
    }), "\n", _jsx(_components.h3, {
      id: "синтетично-сравнение",
      children: "Синтетично сравнение"
    }), "\n", _jsxs(_components.p, {
      children: ["Основното сравнително окончание за прилагателни ", _jsx(_components.code, {
        children: "-ějši"
      }), " (", _jsx(_components.code, {
        children: "-ejši"
      }), " след мека съгласна), заместващо окончанието ", _jsx(_components.code, {
        children: "-y"
      }), "/", _jsx(_components.code, {
        children: "-i"
      }), ": ", _jsx(TransliteratorElement, {
        children: "bogaty"
      }), " → ", _jsx(TransliteratorElement, {
        children: "bogatějši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "slaby"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "slabějši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "blagy"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "blažejši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "svěži"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "svěžejši"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Тези окончания могат просто да се превърнат в наречия чрез замяна на елемента ", _jsx(_components.code, {
        children: "-ši"
      }), " с ", _jsx(_components.code, {
        children: "-e"
      }), " (давайки окончанието ", _jsx(_components.code, {
        children: "-ěje"
      }), "/", _jsx(_components.code, {
        children: "-eje"
      }), " вместо наречното окончание ", _jsx(_components.code, {
        children: "-o"
      }), "/", _jsx(_components.code, {
        children: "-e"
      }), "): ", _jsx(TransliteratorElement, {
        children: "novo"
      }), " → ", _jsx(TransliteratorElement, {
        children: "nověje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "čisto"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "čistěje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tiho"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "tišeje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "svěže"
      }), " → ", _jsx(TransliteratorElement, {
        children: "svěžeje"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Изключение правят прилагателните на ", _jsx(_components.code, {
        children: "-ky"
      }), ", ", _jsx(_components.code, {
        children: "-eky"
      }), ", ", _jsx(_components.code, {
        children: "-oky"
      }), ", , които имат ", _jsx(_components.code, {
        children: "-ši"
      }), " вместо: ", _jsx(TransliteratorElement, {
        children: "kratky"
      }), " → ", _jsx(TransliteratorElement, {
        children: "kratši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tenky"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "tenši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "daleky"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "dalši"
      }), ", ", _jsx(TransliteratorElement, {
        children: "vysoky"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "vysši"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Сравненията на тези прилагателни могат да бъдат адвербиализирани чрез добавяне на окончание ", _jsx(_components.code, {
        children: "-je"
      }), " към корена, причинявайки ", _jsx(_components.a, {
        href: "/bg/learn/phonology#iotation",
        children: "йотация"
      }), " на предходната(ите) съгласна(и): ", _jsx(TransliteratorElement, {
        children: "daleko"
      }), " → ", _jsx(TransliteratorElement, {
        children: "dalje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "široko"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "širje"
      }), ", ", _jsx(TransliteratorElement, {
        children: "vysoky"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "vyše"
      }), ", ", _jsx(TransliteratorElement, {
        children: "blizko"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "bliže"
      }), ", ", _jsx(TransliteratorElement, {
        children: "rědko"
      }), "  → ", _jsx(TransliteratorElement, {
        children: "rědže"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "нередовни-сравнения",
      children: "Нередовни сравнения"
    }), "\n", _jsx(_components.p, {
      children: "Седем прилагателни имат неправилно сравнение:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "dobry"
        }), " „добър” → ", _jsx(TransliteratorElement, {
          children: "lěpši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "lěpje"
        }), ") или ", _jsx(TransliteratorElement, {
          children: "lučši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "lučše"
        }), ") „по-добър”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "zly"
        }), " „лош” → ", _jsx(TransliteratorElement, {
          children: "gorši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "gorje"
        }), ") „по-лош”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "veliky"
        }), " „голям, голям” → ", _jsx(TransliteratorElement, {
          children: "večši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "veče"
        }), ") или ", _jsx(TransliteratorElement, {
          children: "bolši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "bolje"
        }), ") „по-голям, по-голям”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "maly"
        }), " „малко, малко” → ", _jsx(TransliteratorElement, {
          children: "menši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "menje"
        }), ") „по-малко, по-малко”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "blagy"
        }), " „приятно, радостно” → ", _jsx(TransliteratorElement, {
          children: "unši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "unje"
        }), ") „по-приятно/радостно”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "legky"
        }), " „лесно, леко” → ", _jsx(TransliteratorElement, {
          children: "legši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "legše"
        }), ") „по-лесно, по-леко”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "mekky"
        }), " „меко” → ", _jsx(TransliteratorElement, {
          children: "mekši"
        }), " (", _jsx(_components.abbr, {
          title: "наречие",
          children: "нар."
        }), " ", _jsx(TransliteratorElement, {
          children: "mekše"
        }), ") „по-меко”"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Не е невъзможно да се използват редовни форми на тези прилагателни (като ", _jsx(TransliteratorElement, {
        children: "dobrějši"
      }), " или ", _jsx(TransliteratorElement, {
        children: "zlějši"
      }), "), но за средния славянин това ще изглежда детински или изкуствено."]
    }), "\n", _jsx(_components.h3, {
      id: "суперлатив",
      children: "Суперлатив"
    }), "\n", _jsxs(_components.p, {
      children: ["Суперлативът се формира чрез добавяне на префикса ", _jsx(_components.code, {
        children: "naj-"
      }), " към сравнението: ", _jsx(TransliteratorElement, {
        children: "najnovějši"
      }), " (", _jsx(_components.abbr, {
        title: "прилагателно",
        children: "прил."
      }), "), ", _jsx(TransliteratorElement, {
        children: "najnověje"
      }), " (", _jsx(_components.abbr, {
        title: "наречие",
        children: "нар."
      }), "). Това работи и за аналитичното сравнение: ", _jsx(TransliteratorElement, {
        children: "najvyše sintetičny"
      }), " или ", _jsx(TransliteratorElement, {
        children: "najbolje sintetičny"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Като средство за опростяване, това окончание може да бъде добавено и към положителното вместо това (така се правят суперлативи на български и македонски): ", _jsx(TransliteratorElement, {
        children: "najnovy"
      }), " (", _jsx(_components.abbr, {
        title: "прилагателно",
        children: "прил."
      }), "), ", _jsx(TransliteratorElement, {
        children: "najnovo"
      }), " (", _jsx(_components.abbr, {
        title: "наречие",
        children: "нар."
      }), ")."]
    }), "\n", _jsx(_components.h3, {
      id: "допълнителни-форми",
      children: "Допълнителни форми"
    }), "\n", _jsxs(_components.p, {
      children: ["Наречията ", _jsx(TransliteratorElement, {
        children: "menje"
      }), " и ", _jsx(TransliteratorElement, {
        children: "najmenje"
      }), " могат да се използват за изразяване на противоположното значение на ", _jsx(TransliteratorElement, {
        children: "vyše"
      }), "/", _jsx(TransliteratorElement, {
        children: "bolje"
      }), "  и ", _jsx(TransliteratorElement, {
        children: "najvyše"
      }), "/", _jsx(TransliteratorElement, {
        children: "najbolje"
      }), ", , което означава съответно „по-малко” и „най-малко”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Префиксът ", _jsx(_components.code, {
        children: "prě-"
      }), ", прикрепен към положителния, може да се използва и като вид суперлатив, изразяващ крайна или прекомерна степен („много“, „също“)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Префиксът ", _jsx(_components.code, {
        children: "ne-"
      }), " създава отрицание: ", _jsx(TransliteratorElement, {
        children: "neprijetny"
      }), " „не е приятно, неприятно”."]
    }), "\n", _jsx(_components.h3, {
      id: "пример",
      children: "Пример"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "prosty"
        }), " „прост” (прилагателно, положително)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "prosto"
        }), " „просто” (наречие, положително)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "prostějši"
        }), " „по-просто” или ", _jsx(TransliteratorElement, {
          children: "vyše prosty"
        }), " или ", _jsx(TransliteratorElement, {
          children: "bolje prosty"
        }), " „по-просто, по-просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "prostěje"
        }), " „по-просто” или ", _jsx(TransliteratorElement, {
          children: "vyše prosto"
        }), " или ", _jsx(TransliteratorElement, {
          children: "bolje prosto"
        }), " „по-просто, по-просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "najprostějši"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najprosty"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najvyše prosty"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najbolje prosty"
        }), " „най-простият”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "najprostěje"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najprosto"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najvyše prosto"
        }), " или ", _jsx(TransliteratorElement, {
          children: "najbolje prosto"
        }), " „най-просто, най-просто“"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "menje prosty"
        }), " „по-малко просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "menje prosto"
        }), " „по-малко просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "najmenje prosty"
        }), " „най-малко просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "najmenje prosto"
        }), " „най-малко просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "neprosty"
        }), " „не е просто”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "prěprosty"
        }), " „твърде просто, прекалено просто, изключително просто”"]
      }), "\n"]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

